import { render, staticRenderFns } from "./PowerStation.vue?vue&type=template&id=27579542&scoped=true"
import script from "./PowerStation.vue?vue&type=script&lang=js"
export * from "./PowerStation.vue?vue&type=script&lang=js"
import style0 from "./PowerStation.vue?vue&type=style&index=0&id=27579542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27579542",
  null
  
)

export default component.exports